import React, { useState, Fragment } from 'react';
import { Button } from 'reactstrap';

import AddRoomForm from './AddRoomForm';

export default function AddRoomCard({ propertyId, locale, categoryList }) {
  const [visible, setVisible] = useState(false);
  return (
    <Fragment>
      <Button
        color="primary"
        outline
        size="xs"
        onClick={() => {
          setVisible(!visible);
        }}
      // style={{ width: '100%', borderRadius: '6px' }}
      >
        + Add Room
      </Button>

      <AddRoomForm
        room={{}}
        propertyId={propertyId}
        visible={visible}
        toggle={() => {
          setVisible(!visible);
        }}
        locale={locale}
        categoryList={categoryList}
      />
    </Fragment>
  );
}
